import Chip from 'components/atoms/Chip/Chip';
import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';
import Image from 'components/atoms/Image/Image';
import Rating from 'components/atoms/Rating/Rating';
import Title from 'components/atoms/Title/Title';
import Divider from 'components/atoms/Divider/Divider';
import { Trans } from 'react-i18next';

import React, { Fragment } from 'react';
import { useTheme } from '@material-ui/core';
import Box from 'components/atoms/Box/Box';
import { useHistory } from 'react-router-dom';
import { ROUTE_TRAIT_DETAILS } from 'routes';

export default function RoutineTile(props) {
  const { image, ratingValue, ratingOnChange, predispositionItems } = props;
  const theme = useTheme();
  const themeColor = theme && theme.palette.primary.main;
  const history = useHistory();

  return (
    <Fragment>
      <Box mb={2}>
        {' '}
        <Image alt="logo" src={image} />
      </Box>

      <GridContainer
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <GridItem>
          <Box mb={2}>
            <Title variant="h2" textSize="18px" textColor={themeColor}>
              <Trans i18nKey="dna24.userReview" />
            </Title>
          </Box>
        </GridItem>
        <GridItem>
          <Box mb={2}>
            <Rating value={ratingValue} onChange={ratingOnChange} />
          </Box>
        </GridItem>
      </GridContainer>

      <Divider />
      <Box>
        <Title variant="h2" textSize="18px">
          <Trans i18nKey="dna24.recommendedFor" />
        </Title>
      </Box>
      {predispositionItems && (
        <Box mb={2}>
          {predispositionItems.map((item, index) => (
            <Box
              display="inline-block"
              mr={1}
              mt={1}
              onClick={() =>
                history.push(`${ROUTE_TRAIT_DETAILS}?code=${item.link}`)
              }
            >
              <Chip key={index} label={item.label} />
            </Box>
          ))}
        </Box>
      )}
    </Fragment>
  );
}
